import { FC, useMemo } from 'react';
import styled from 'styled-components';
import {
  LongreadBlockWrapper,
  ColoredBlock as StyledColoredBlock,
  ColoredTextBlock,
} from '../../styles/LongreadBlockRenderer.styles';
import { colorObj, colorObjFonts, invertColor } from '../../utils/colorUtils';
import { OffsetContainer } from './ColoredBlock';

interface LinkBlockProps {
  block: any;
  backgroundColor?: string;
}
const LinkColoredTextBlock = styled(ColoredTextBlock)<{ $hoverColor: string }>`
  p {
    display: inline;
    margin-right: 8px;
  }

  a {
    cursor: pointer;
    color: inherit;
    text-decoration: none;
    pointer-events: auto;
  }

  a:hover {
    color: ${({ $hoverColor }) => $hoverColor};

    svg path {
      fill: ${({ $hoverColor }) => $hoverColor};
    }
  }
`;

export const LinkBlock: FC<LinkBlockProps> = ({ block }) => {
  const postColor = useMemo(() => {
    if (!block.color) return block.postColor || '#FEFEFE';
    return block.color[0] === '#' ? block.color : (colorObj[block.color] || '#FEFEFE');
  }, [block.color, block.postColor]);

  const fontColor = useMemo(() => {
    if (!block.color) return block.fontColor || '#151514';
    if (block.color[0] === '#') return invertColor(block.color, '#FEFEFE', '#151514');
    return colorObjFonts[block.color] || '#151514';
  }, [block.color, block.fontColor]);

  const hoverColor = fontColor === 'white' ? '#CDCDCD' : '#70706F';

  const href = block.linkText || '';

  return (
    <LongreadBlockWrapper>
      <StyledColoredBlock backgroundColor={postColor} textColor={fontColor}>
        {block.text && (
          <OffsetContainer>
            <LinkColoredTextBlock textColor={fontColor} $hoverColor={hoverColor}>
              <a
                href={href}
                target="_blank"
                rel="noreferrer"
                onClick={(e) => e.stopPropagation()}
              >
                <span style={{ display: 'inline' }}>
                  <span>{block.text}</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    style={{ display: 'inline-block', verticalAlign: 'middle', marginLeft: 4 }}
                  >
                    <path
                      d="M2.42948 16L0 13.5721L10.2567 3.31175H2.55146L2.57179 0H16V13.4298H12.6658L12.6861 5.73968L2.42948 16Z"
                      fill={fontColor}
                    />
                  </svg>
                </span>
              </a>
            </LinkColoredTextBlock>
          </OffsetContainer>
        )}
      </StyledColoredBlock>
    </LongreadBlockWrapper>
  );
};
import { FC, useMemo } from 'react';
import styled from 'styled-components';
import {
  LongreadBlockWrapper,
  ColoredBlock as StyledColoredBlock,
  ColoredTextBlock,
} from '../../styles/LongreadBlockRenderer.styles';
import { colorObj, colorObjFonts, invertColor } from '../../utils/colorUtils';
import { OffsetContainer } from './ColoredBlock';

interface LinkBlockProps {
  block: any;
  backgroundColor?: string;
}
const LinkColoredTextBlock = styled(ColoredTextBlock)<{ $hoverColor: string }>`
  p {
    display: inline;
    margin-right: 8px;
  }

  a {
    cursor: pointer;
    color: inherit;
    text-decoration: none;
    pointer-events: auto;
  }

  a:hover {
    color: ${({ $hoverColor }) => $hoverColor};

    svg path {
      fill: ${({ $hoverColor }) => $hoverColor};
    }
  }
`;

export const LinkBlock: FC<LinkBlockProps> = ({ block }) => {
  const postColor = useMemo(() => {
    if (!block.color) return block.postColor || '#FEFEFE';
    return block.color[0] === '#' ? block.color : (colorObj[block.color] || '#FEFEFE');
  }, [block.color, block.postColor]);

  const fontColor = useMemo(() => {
    if (!block.color) return block.fontColor || '#151514';
    if (block.color[0] === '#') return invertColor(block.color, '#FEFEFE', '#151514');
    return colorObjFonts[block.color] || '#151514';
  }, [block.color, block.fontColor]);

  const hoverColor = fontColor === 'white' ? '#CDCDCD' : '#70706F';

  const href = block.linkText || '';

  return (
    <LongreadBlockWrapper>
      <StyledColoredBlock backgroundColor={postColor} textColor={fontColor}>
        {block.text && (
          <OffsetContainer>
            <LinkColoredTextBlock textColor={fontColor} $hoverColor={hoverColor}>
              <a
                href={href}
                target="_blank"
                rel="noreferrer"
                onClick={(e) => e.stopPropagation()}
              >
                <span style={{ display: 'inline' }}>
                  <span>{block.text}</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    style={{ display: 'inline-block', verticalAlign: 'middle', marginLeft: 4 }}
                  >
                    <path
                      d="M2.42948 16L0 13.5721L10.2567 3.31175H2.55146L2.57179 0H16V13.4298H12.6658L12.6861 5.73968L2.42948 16Z"
                      fill={fontColor}
                    />
                  </svg>
                </span>
              </a>
            </LinkColoredTextBlock>
          </OffsetContainer>
        )}
      </StyledColoredBlock>
    </LongreadBlockWrapper>
  );
};
